<template>
  <div class="el-centered fade-in">
    <main
      class="el-stripe"
      style="margin: auto"
    >
      <section class="el-bounds _narrow">
        <div class="el-centered__main">
          <div class="el-centered__main_body">

            <slot />

            <emd-footer />
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import EmdFooter from '@/components/emerald/organisms/EmdFooter.vue'
export default {
  name: 'App',
  components: {
    EmdFooter
  }
}
</script>
